import { apiBaseUrl } from '../api';

const basedGetUrlRequestLogedIn = async url => {
  const newApiBaseUrl = apiBaseUrl();
  try {
    const response = await fetch(newApiBaseUrl + url, {
      method: 'GET',
      // credentials: 'include',
      headers: {
        'Content-Type': 'application/transit+json',
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
};

export default basedGetUrlRequestLogedIn;
